export const modules = [
  {
    name: "company",
    fileName: "CreateCompany_SampleData",
    headers: [
      "Company Name",
      "Website",
      "Industry",
      "Business Type",
      "Employee Size",
      "Company Account Owner",
      "Email Address",
      "Mobile Number",
      "Address",
      "Country",
      "State",
      "City",
      "Zipcode",
      "Facebook",
      "Linkedin",
      "Instagram",
      "Twitter",
      "About",
      "Rating",
    ],
    data: [
      [
        "TechNova Solutions Pvt Ltd",
        "https://www.technova.com",
        "Information Technology",
        "B2B",
        "201-500",
        "Piyush Khade",
        "contact@technova.com",
        "9876543210",
        "Asia/Kolkata",
        "3rd Floor, IT Park, Hinjewadi",
        "India",
        "Maharashtra",
        "Pune",
        "411057",
        "https://facebook.com/technova",
        "https://linkedin.com/company/technova",
        "https://instagram.com/technova",
        "https://twitter.com/technova",
        "Leading IT solutions provider in India",
        "4.5",
      ],
      [
        "FinEdge Global",
        "https://www.finedgeglobal.com",
        "Finance",
        "B2B",
        "51-200",
        "Rahul Sharma",
        "info@finedgeglobal.com",
        "9123456780",
        "Asia/Kolkata",
        "Sector 62, Business Tower",
        "India",
        "Delhi",
        "New Delhi",
        "110096",
        "https://facebook.com/finedge",
        "https://linkedin.com/company/finedge",
        "https://instagram.com/finedge",
        "https://twitter.com/finedge",
        "Financial consulting and investment services",
        "4.2",
      ],
    ],
  },
  {
    name: "contact",
    fileName: "CreateContacts_SampleData",
    headers: [
      "First Name",
      "Last Name",
      "Contact Owner",
      "Report To",
      "Email Address",
      "Mobile Number",
      "Address",
      "Country",
      "State",
      "City",
      "Zipcode",
      "Facebook",
      "Linkedin",
      "Instagram",
      "Twitter",
      "Company",
      "Department",
      "Designation",
      "Lead Source",
      "Notes",
      "Contact Manager",
      "Shipment Weight",
      "Decision Maker",
      "Due Date",
    ],
    data: [
      [
        "Amit",
        "Sharma",
        "rohit yeginwar",
        "Sales Head",
        "amit.sharma@email.com",
        "9876543210",
        "3rd Floor IT Park Hinjewadi",
        "India",
        "Maharashtra",
        "Pune",
        "411057",
        "facebook.com/amitsharma",
        "linkedin.com/in/amitsharma",
        "instagram.com/amitsharma",
        "twitter.com/amitsharma",
        "BCCL",
        "Sales",
        "Senior Sales Executive",
        "Website",
        "Interested in enterprise plan",
        "Rahul Mehta",
        "25 kg",
        "Yes",
        "2026-02-15",
      ],
      [
        "Ms.",
        "Sneha",
        "Patil",
        "Rahul Sharma",
        "Public",
        "sneha.patil@email.com",
        "9123456789",
        "Business Tower Sector 62",
        "India",
        "Delhi",
        "New Delhi",
        "110096",
        "facebook.com/snehapatil",
        "linkedin.com/in/snehapatil",
        "instagram.com/snehapatil",
        "twitter.com/snehapatil",
        "FinEdge Global",
        "Marketing",
        "Marketing Lead",
        "Referral",
        "Follow up required next week",
        "Anita Verma",
        "10 kg",
        "No",
        "2026-01-25",
      ],
    ],
  },
  {
    name: "leads",
    fileName: "AddLeads_SampleData",
    headers: [
      "Contact Name",
      "Pipeline",
      "Pipeline Stage",
      "Owner",
      "Expexted Closure On",
      "Expected Closure Time",
      "Requirement",
      "Product and Services",
      "Quantity",
      "Budget",
      "Lead Source",
    ],
    data: [
      [
        "Amit Sharma",
        "Sales Pipeline",
        "Qualified",
        "Piyush Khade",
        "2026-02-20",
        "15:00",

        "CRM implementation",
        "CRM Software Customization",
        "25",
        "500000",
        "Website",
      ],
      [
        "Sneha Patil",
        "Enterprise Pipeline",
        "Proposal Sent",
        "Rahul Sharma",
        "2026-03-05",
        "16:00",
        "Accounting automation",
        "Finance Management Software",
        "15",
        "750000",
        "Referral",
      ],
    ],
  },
  {
    name: "deals",
    fileName: "AddDeals_SampleData",
    headers: [
      "Deal Name",
      "Currency",
      "Requirement",
      "Product and Services",
      "Quantity",
      "Budget",
      "Contact Name",
      "Pipeline",
      "Pipeline Stage",
      "Owner",
      "Expexted Closure On",
      "Expected Closure Time",
    ],
    data: [
      [
        "CRM Implementation Deal",
        "INR",
        "Customer relationship management setup",
        "CRM Software Customization",
        "25",
        "500000",
        "Amit Sharma",
        "Sales Pipeline",
        "Qualified",
        "Piyush Khade",
        "2026-02-20",
        "15:00",
      ],
      [
        "Accounting Automation Project",
        "INR",
        "Automate accounting and billing",
        "Finance Management Software",
        "15",
        "750000",
        "Sneha Patil",
        "Enterprise Pipeline",
        "Proposal Sent",
        "Rahul Sharma",
        "2026-03-05",
        "16:30",
      ],
    ],
  },
  {
    name: "quotation",
    fileName: "Quotation_SampleData",
    headers: [
      "Contact",
      "Reference",
      "Quote Date",
      "Expiry Date",
      "Company Account Owner",
      "Deal",
      "Short Description",
      "Product",
      "Quantity",
      "Product Description",
      "Rate",
      "GST(%)",
      "Discount Type",
      "Discount",
      "Amount",
      "Sub Total",
      "Grand Total",
      "Specail Discount ",
      "Specail Discount Type",
      "Specail Discount Amount",
      "Shipping Charge",
      "GST Amount",
      "Customer Note",
      "Terms and Conditions",
      "Billing Address",
      "Billing Country",
      "Billing State",
      "Billing City",
      "Billing Zipcode",
      "Shipping Address",
      "shipping Country",
      "shipping State",
      "shipping City",
      "shipping Zipcode",
    ],
    data: [
      [
        "Ram Shawant",
        "REF-QUO-001",
        "2026-01-15",
        "2026-02-15",
        "Jhon",
        "i phone",
        "CRM setup for enterprise client",
        "Chili Masala",
        "10",
        "CRM Software License",
        "5000",
        "10",
        "Percent",
        "10",
        "45000",
        "45000",
        "45550",
        "10",
        "percent",
        "4500",
        "1000",
        "4050",
        "Looking forward to quick approval",
        "Payment within 30 days",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
      ],
      [
        "Rohit Sharma",
        "REF-QUO-001",
        "2026-01-15",
        "2026-02-15",
        "Piyush Singh",
        "new deal",
        "CRM setup for enterprise client",
        "Chili Masala",
        "10",
        "CRM Software License",
        "5000",
        "10",
        "Percent",
        "10",
        "45000",
        "45000",
        "45550",
        "10",
        "percent",
        "4500",
        "1000",
        "4050",
        "Looking forward to quick approval",
        "Payment within 30 days",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
      ],
    ],
  },
  {
    name: "purchase_order",
    fileName: "purchase_SampleData",
    headers: [
      "Contact",
      "Reference",
      "PO Date",
      "Delivery Date",
      "Owner",
      "GSTN",
      "Short Description",
      "Product",
      "Quantity",
      "Product Description",
      "Rate",
      "GST(%)",
      "Discount Type",
      "Discount",
      "Amount",
      "Sub Total",
      "Grand Total",
      "Specail Discount ",
      "Specail Discount Type",
      "Specail Discount Amount",
      "GST Amount",
      "Customer Note",
      "Terms and Conditions",
      "Billing Address",
      "Billing Country",
      "Billing State",
      "Billing City",
      "Billing Zipcode",
      "Shipping Address",
      "shipping Country",
      "shipping State",
      "shipping City",
      "shipping Zipcode",
    ],
    data: [
      [
        "Sachin Agrawal",
        "REF-QUO-001",
        "2026-01-15",
        "2026-02-15",
        "Vicky Shah",
        "qmqps4291m",
        "CRM setup for enterprise client",
        "Chili Masala",
        "10",
        "CRM Software License",
        "5000",
        "10",
        "Percent",
        "10",
        "45000",
        "45000",
        "45550",
        "10",
        "percent",
        "4500",
        "4050",
        "Looking forward to quick approval",
        "Payment within 30 days",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
      ],
      [
        "Himanshu Pandit",
        "REF-QUO-001",
        "2026-01-15",
        "2026-02-15",
        "Seema Singh",
        "qmqps4291m",
        "CRM setup for enterprise client",
        "Chili Masala",
        "10",
        "CRM Software License",
        "5000",
        "10",
        "Percent",
        "10",
        "45000",
        "45000",
        "45550",
        "10",
        "percent",
        "4500",
        "4050",
        "Looking forward to quick approval",
        "Payment within 30 days",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
      ],
    ],
  },
  {
    name: "sales_order",
    fileName: "Sales_SampleData",
    headers: [
      "Contact",
      "Sales Order Date",
      "Shipment Date",
      "Company Account Owner",
      "Deal",
      "Quotation Number",
      "Payment Terms",
      "Short Description",
      "Product",
      "Quantity",
      "Product Description",
      "Rate",
      "GST(%)",
      "Discount Type",
      "Discount",
      "Discounted_amount",
      "Amount",
      "Sub Total",
      "Grand Total",
      "Specail Discount ",
      "Specail Discount Type",
      "Specail Discount Amount",
      "Shipping Charge",
      "GST Amount",
      "Customer Note",
      "Terms and Conditions",
      "Billing Address",
      "Billing Country",
      "Billing State",
      "Billing City",
      "Billing Zipcode",
      "Shipping Address",
      "shipping Country",
      "shipping State",
      "shipping City",
      "shipping Zipcode",
    ],
    data: [
      [
        "Janvi Singh",
        "REF-QUO-001",
        "2026-01-15",
        "2026-02-15",
        "Raj Singh",
        "i phone",
        "QUOTE-233",
        "30 Days",
        "CRM setup for enterprise client",
        "Chili Masala",
        "10",
        "CRM Software License",
        "5000",
        "10",
        "Percent",
        "10",
        "5000",
        "45000",
        "45000",
        "45550",
        "10",
        "percent",
        "4500",
        "1000",
        "4050",
        "Looking forward to quick approval",
        "Payment within 30 days",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
      ],
      [
        "Muskan",
        "REF-QUO-001",
        "2026-01-15",
        "2026-02-15",
        "Sachin",
        "new deal",
        "QUOTE-233",
        "30 Days",
        "CRM setup for enterprise client",
        "Chili Masala",
        "10",
        "CRM Software License",
        "5000",
        "10",
        "Percent",
        "10",
        "5000",
        "45000",
        "45000",
        "45550",
        "10",
        "percent",
        "4500",
        "1000",
        "4050",
        "Looking forward to quick approval",
        "Payment within 30 days",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
        "C-403",
        "India",
        "Gujrat",
        "Vadodara",
        "390019",
      ],
    ],
  },
  {
    name: "master_product",
    fileName: "Products_Services_SampleData",
    headers: [
      "Product & Services",
      "Price",
      "Tax",
      "Description",
      "HSC_SAC",
      "Category",
      "Unit",
    ],
    data: [
      [
        "Crm",
        "5000",
        "10",
        "Enterprise CRM license with full features",
        "998313",
        "Software",
        "License",
      ],
      [
        "Pug Crm",
        "25000",
        "18",
        "End-to-end CRM setup and customization",
        "998314",
        "Service",
        "Project",
      ],
      [
        "Panda Lms",
        "10000",
        "18",
        "One year technical support and maintenance",
        "998315",
        "Service",
        "Year",
      ],
      
    ],
  },
  {
    name: "lead_source",
    fileName: "Lead_Source_SampleData",
    headers: ["Lead Source", "Description"],
    data: [
      ["Website", "Leads generated from company website"],
      ["Referral", "Leads referred by existing customers or partners"],
      ["Social Media", "Leads captured from social media platforms"],
      ["Email Campaign", "Leads generated through email marketing campaigns"],
    ],
  },
  {
    name: "department",
    fileName: "Department_SampleData",
    headers: ["Department", "Description"],
    data: [
      ["Sales", "Handles customer acquisition and deal closures"],
      ["Marketing", "Responsible for lead generation and brand promotion"],
      [
        "Human Resources",
        "Manages hiring, employee relations, and company policies",
      ],
      ["Finance", "Oversees billing, payments, and financial reporting"],
      ["IT Support", "Maintains internal systems and technical infrastructure"],
    ],
  },
  {
    name: "designation",
    fileName: "Designation_SampleData",
    headers: ["Designation", "Description"],
    data: [
      [
        "Sales Executive",
        "Responsible for managing leads and closing sales deals",
      ],
      [
        "Marketing Manager",
        "Plans and executes marketing campaigns and strategies",
      ],
      ["HR Executive", "Handles recruitment, onboarding, and employee records"],
      ["Accountant", "Manages invoices, payments, and financial accounts"],
      ["Software Engineer", "Develops and maintains software applications"],
    ],
  },
];
